import { ThemeModule } from '../../front/lib/ThemeModule';
export class InnerContainer extends ThemeModule {
    constructor() {
        super(...arguments);
        this.wrapperEl = this.getElementById('wrapper');
        this.innerEl = this.getElementById('inner');
        this.readMoreEl = this.getElementById('readMore');
        this.readMoreBtnEl = this.getElementById('readMoreBtn');
        this.drapeEl = this.getElementById('drape');
        this.isExpanded = false;
        this.numLines = this.getDataPropInt('maxLines', 0);
        this.shrinkHeight = this.numLines * 16 * 1.6;
    }
    init() {
        if (this.readMoreEl && this.numLines) {
            this.initReadMore();
        }
    }
    initReadMore() {
        var _a, _b;
        if (this.innerEl.offsetHeight > this.shrinkHeight) {
            this.wrapperEl.style.height = this.shrinkHeight + 'px';
            this.showDrape();
        }
        if (this.wrapperEl.offsetHeight < this.innerEl.offsetHeight) {
            (_a = this.readMoreEl) === null || _a === void 0 ? void 0 : _a.classList.add('is--visible');
            (_b = this.readMoreBtnEl) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
                this.toggleContent();
            });
        }
    }
    toggleContent() {
        this.isExpanded ? this.shrinkContent() : this.expandContent();
    }
    expandContent() {
        var _a;
        this.wrapperEl.style.height = ((_a = this.innerEl) === null || _a === void 0 ? void 0 : _a.offsetHeight) + 'px';
        this.setTitle('Läs mindre');
        this.hideDrape();
        this.root.classList.add('is--expanded');
        this.isExpanded = true;
    }
    shrinkContent() {
        this.wrapperEl.style.height = this.shrinkHeight + 'px';
        this.setTitle('Läs mer');
        this.showDrape();
        this.root.classList.remove('is--expanded');
        this.isExpanded = false;
    }
    showDrape() {
        this.drapeEl.classList.add('is--visible');
    }
    hideDrape() {
        this.drapeEl.classList.remove('is--visible');
    }
    setTitle(title) {
        var _a;
        const titleEl = (_a = this.readMoreBtnEl) === null || _a === void 0 ? void 0 : _a.querySelector('.themeButton-title');
        if (!titleEl) {
            return;
        }
        titleEl.innerHTML = title;
    }
}
